// extracted by mini-css-extract-plugin
export var compactFilters = "_dy-4";
export var detailImage = "_dy-1";
export var dropdownContainer = "_dy-2";
export var imageContainer = "_dy-0";
export var selectedCard = "_dy-3";